import { Component, computed, DestroyRef, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationConfig, getThemeConfig, HeroVariant, RoutingNames } from 'shared';
import { HeroComponent, TopBarComponent } from 'design-system-rijks';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthenticationService } from '../../config/authentication-service';

@Component({
  selector: 'lib-request-set-password-confirmation-page',
  templateUrl: './request-password-set-confirmation-page.component.html',
  styleUrl: './request-password-set-confirmation-page.component.scss',
  imports: [CommonModule, HeroComponent, TopBarComponent],
})
export class RequestPasswordSetConfirmationPageComponent implements OnInit {
  email: string | undefined;

  logoVariant!: HeroVariant;
  logoUrl = '';
  logoAltText = '';

  theme: AuthenticationConfig['theme'];

  private readonly route = inject(ActivatedRoute);
  private readonly config = inject(AuthenticationConfig);
  private readonly destroyRef = inject(DestroyRef);
  private readonly authenticationService = inject(AuthenticationService);

  ngOnInit() {
    this.theme = this.config.theme;

    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.email = params['email'];
      if (this.email) {
        this.authenticationService.setPasswordRequest(this.email).subscribe();
      }
    });
  }

  public useRijksVersion = computed(() => {
    const cfg = getThemeConfig(this.theme);
    if (cfg.logoVariant) this.logoVariant = cfg.logoVariant;
    this.logoUrl = cfg.logoUrl ?? '';
    this.logoAltText = cfg.logoAltText ?? '';
    return cfg.isRijksTheme;
  });
  protected readonly RoutingNames = RoutingNames;
}
